import { Component } from 'react';
import ACBadRequestError from 'academy-common-lib/components/error/ACBadRequestError';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, {
      extra: errorInfo
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_jsx(ACBadRequestError, {});
    }
    return this.props.children;
  }
}
export default ErrorBoundary;